import { createSlice } from '@reduxjs/toolkit';
import { ArchivedDiscountsState } from './archivedDiscountsTypes';
import { fetchArchivedDiscountsThunk } from './archivedDiscounts.thunk';

const initialState: ArchivedDiscountsState = {
  archivedDiscounts: [],
  loading: false,
  error: null,
  refreshToken: 0,
};
const archivedDiscountsSlice = createSlice({
  name: 'archivedDiscounts',
  initialState,
  reducers: {
    triggerRefresh: (state) => {
      state.refreshToken += 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchArchivedDiscountsThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchArchivedDiscountsThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.archivedDiscounts = action.payload;
    });
    builder.addCase(fetchArchivedDiscountsThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload ?? null;
    });
  },
});

export const { triggerRefresh } = archivedDiscountsSlice.actions;
export default archivedDiscountsSlice.reducer;
